<template>
  <a class="resource-card"
     :href=null
     target="_blank"
     :class="{
       'hide' : title === '',
       'resource-card-isef' : $isIsef,
       'resource-card-ajas' : $isAjas,
       'resource-card-ysc' : $isYSC,
       'neweng-resources' : isResources,
       [name] : name}">
    <div class="image"
      :class="{
        'cadsoft-fix' : title === 'Design & Build Your Own Makerspace',
        'image-ysc' : $isYSC,
        'image-isef' : $isIsef,
        'image-broadcom' : $isBroadcomMasters,
        'image-ohio' : $isOhioScience,
        'image-sts' : $isSts}"
      v-bind:style="{ backgroundImage: imageBackground }">
    </div>
    <div class="info"
         :class="{
      'info-ysc' : $isYSC,
      'info-auditorium': isYSCAuditorium,
      'info-ajas' : $isAjas,
      'info-ohio' : $isOhioScience,
      'info-cnmiiwsf' : $isCnmiIwsf,
      'info-sts' : $isSts,
      'memory-height-fix' : title === 'Post a favorite STS memory, photo or advice',
      'award-ceremony-height' : title === 'Regeneron STS Awards Ceremony',
      'info-sts-regeneron' : $isSts,
      'info-height-sts' : title === 'Top 300 Scholars'
      }"
    >
      <p v-if="!hideYscWebinarDate" class="title"
         :class="{
        'title-ysc' : $isYSC,
        'title-ajas' : $isAjas,
        'title-ohio' : $isOhioScience,
        'title-cnmiiwsf' : $isCnmiIwsf,
        'title-sts' : $isSts
        }">
        {{ title }}
      </p>
      <p class="subtitle"
         :class="{
        'subtitle-ysc' : $isYSC,
        'subtitle-ajas' : $isAjas || $isIsef,
        'subtitle-ohio' : $isOhioScience,
        'subtitle-cnmiiwsf' : $isCnmiIwsf,
        'subtitle-sts' : $isSts,
        'subtitle-ysc-webinar' : isYscWebinar
        }">
        {{ formatSubTitle(subtitle) }}
      </p>
    </div>
  </a>
</template>

<script>
import imageProxy from '@/libs/image-proxy'

export default {
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    },
    image: {
      type: String,
      required: true
    },
    url: {
      type: String
    },
    name: {
      type: null
    },
    isResources: {
      type: Boolean,
      required: true
    },
    hideYscWebinarDate: {
      type: Boolean,
      required: true
    },
    isYscWebinar: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    isYSCAuditorium: function () {
      return this.$route.fullPath.includes('auditorium') && this.$isYSC
    },
    imageBackground: function () {
      return `url('${imageProxy.proxy(this.image, { width: 350, height: 250, quality: 75 })}')`
    }
  },
  methods: {
    formatSubTitle: function (subTitle) {
      if (this.title.toLowerCase() === subTitle.toLowerCase()) return ''
      if (subTitle && subTitle.length > 155) return subTitle.slice(0, 155) + '...'
      return subTitle
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';

  .hide {
    display: none;
  }

  .resource-card {
    width: 354px;
    height: 370px;
    position: relative;
    cursor: pointer;
    display: flex;
    flex-direction: column;

    -webkit-box-shadow: 0px 2px 5px 0px rgba(168,168,168,.5);
    -moz-box-shadow: 0px 2px 5px 0px rgba(168,168,168,.5);
    box-shadow: 0px 2px 5px 0px rgba(168,168,168,.5);

    @include hover-cards-effect;

  }

  .image {
    height: 100%;
    width: 100%;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .info {
    font-family: "Roboto", Arial, sans-serif;
    background: white;
    min-height: 30%;
    height: fit-content;
    padding: 0 1rem;
    align-items: flex-start;
    flex-shrink: 0;
    text-overflow: ellipsis;
    word-wrap: break-word;
    word-break: break-word;

    &-auditorium {
      margin-top: -1rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  }

  .title {
    font-weight: 700;
    font-size: .95rem;
    line-height: 1.7rem;
    padding-top: 0.9rem;
  }

  .subtitle {
    font-weight: 400;
    font-size: .85rem;
    line-height: 1.4rem;
    margin-bottom: 1rem;
  }

  .cadsoft-fix {
    background-position-y: 100%;
  }

  .image-broadcom {
    background-size: contain;
    background-position-y: center;
    background-position-x: center;
  }

  @media (max-width: 1190px) {
    .resource-card {
      width: 300px;
      height: 270px;
    }
    .subtitle{
      font-size: .75rem;
    }
    .title {
      padding-top: .1rem !important;
      font-size: .85rem !important;
    }
  }

  @media (max-width: 1070px) {
    .resource-card {
      width: 280px;
      height: 280px;
    }
    .info {
      font-size: .70px;
    }
    .title{
      padding-top: 0rem;
      font-size: .80rem;
    }
  }
  @media (max-width: 1000px) {
    .resource-card {
      width: 47%;
      height: 340px;
    }
    .image {
      height: 71%;
    }
    .title {
      padding-top: 0.9rem;
    }
  }

  @media (max-width: 770px) {
    .image {
      height: 65%;
    }
    .info {
      height: 35%;
    }
    .title {
      padding-top: 0.5rem;
    }

  }

  @media (max-width: 820px) {
    .resource-card {
      width: 47%;
      height: 320px;
    }
    .image{
      height: inherit;
    }
    .title {
      padding-top: 0.5rem;
    }
    .info {
      height: fit-content;
      width: 100%;
      text-overflow: ellipsis;
      word-wrap: break-word;
      word-break: break-word;
    }
  }

  @media (max-width: 680px) {
    .resource-card {
      width: 250px;
      height: 295px;
    }
    .image{
    height: inherit;
  }
    .title {
      padding-top: 0.5rem;
    }
    .info {
      height: fit-content;
      width: 100%;
      text-overflow: ellipsis;
      word-wrap: break-word;
      word-break: break-word;
    }
  }

  @media (max-width: 590px) {
    .resource-card {
      width: 75%;
      min-width: 325px;
      height: 300px;
    }
    .image{
      height: inherit;
    }
    .title {
      padding-top: 0.5rem;
    }
    .info {
      height: fit-content;
      width: 100%;
      text-overflow: ellipsis;
      word-wrap: break-word;
      word-break: break-word;
    }
  }

@media (max-width: 514px) {
}
  @media (max-width: 374px) {
    .resource-card {
      min-width: 290px;
      height: 330px;
    }
  }

  .neweng-resources {
    .info {
      text-align: left;
    }
    .title {
      padding: 0.35rem 0.15rem 0.1rem 0.15rem;
      font-size: 0.85rem;
      line-height: 1.2rem;
      margin: 0;
    }
    .subtitle {
      font-size: 0.75rem;
      line-height: 1.1rem;
      margin-top: 0 !important;
      margin-left: 2.5px;
    }
    .image {
      background-position: 50%;
    }
  }
  .memory-height-fix {
    height: 40%;
    @media (max-width: 810px) {
      height: 44%;
    }
  }
  .award-ceremony-height {
    @include mobile {
      height: 45%;
    }
    height: 70%;
  }
  .subtitle-ysc-webinar {
    font-size-adjust: 0.58;
    font-weight: bold;
    padding-top: 1rem;
  }
</style>
